import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PropertiesService } from '@app/shared/services/properties/properties.service';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-resync-dialog',
  templateUrl: './property-detail-resync-dialog.component.html',
  styleUrls: ['./property-detail-resync-dialog.component.scss'],
})
export class PropertyDetailResyncDialogComponent implements OnInit {
  resyncing: boolean;
  syncUnlinkedFields: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PropertyDetailResyncDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private readonly propertyService: PropertiesService
  ) { }

  ngOnInit(): void { }

  resync() {
    this.resyncing = true;

    this.propertyService.resyncPropertyDetails(
      this.dialogData.property.id,
      this.syncUnlinkedFields
    ).subscribe({
      next: (res: any) => {
        this.resyncing = false;
        this.dialogRef.close(res);
      },
      error: (err) => {
        this.resyncing = false;
      }
    });
  }
}
